import { KbIf } from "@app/components/kb-if/kb-if.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * A version of kbIf that delays the adding of the ng-hide once the value resolves to false to
 * give animations a chance to finish.
 */
@NgComponent({
    token: Token.KbIfDelay,
    dependencies: [
        Token.$Animate
    ]
})
export class KbIfDelay extends KbIf {
    constructor(
        $animate: ng.animate.IAnimateService
    ) {
        super($animate);
        this.watchAtt = "kbIfDelay";
        this.hideDelay = 300;
    }
}